export class MockToken {
    static jsonMap = {
        authHeader: { key: 'authHeader' },
        authValue: { key: 'authValue' },
        portailCode: { key: 'portailCode' },
        portailHeader: { key: 'portailHeader' }
    };

    public authHeader: string = undefined;
    public authValue: string = undefined;
    public portailCode: string = undefined;
    public portailHeader: string = undefined;
}
